export class User {
    email: string;
    isServiceAccount: boolean;
    blocked: boolean;

    constructor(email: string, isServiceAccount: boolean, blocked: boolean) {
        this.email = email;
        this.isServiceAccount = isServiceAccount;
        this.blocked = blocked;
    }
}
